import { Text } from '@/components/atoms/Text';
import { useTranslation } from '@/lib/i18n/i18n.client';
import { cn } from '@/lib/utils';
import successCheckmarkSrc from '~/icons/check-circle.svg';
import errorIconSrc from '~/icons/icon_x-circle.svg';
import iconXCloseSrc from '~/icons/x-close.svg';
import Button from '../../atoms/Button';
import { SvgIcon } from '@/components/SvgIcon';

export type SubmissionStatus = 'idle' | 'success' | 'invalid' | 'error';

const STATUS_CONFIG = (texts: any) => ({
  success: {
    bg: 'bg-success-100 text-success-500 border border-success-500',
    text: texts.submission_status_message.success,
    Icon: successCheckmarkSrc,
  },
  invalid: {
    bg: 'bg-error-100 border border-error-500',
    text: texts.submission_status_message.invalid_email,
    Icon: errorIconSrc,
  },
  error: {
    bg: 'bg-error-100 border border-error-500',
    text: texts.submission_status_message.error,
    Icon: errorIconSrc,
  },
});

export const SubmissionStatusMessage = ({
  status,
  onClose,
  className,
}: {
  status: SubmissionStatus;
  onClose?: () => void;
  className?: string;
}) => {
  const { texts } = useTranslation();

  if (status === 'idle') return null;

  const config = STATUS_CONFIG(texts)[status];

  if (!config) return null;

  const { bg, text, Icon } = config;

  return (
    <div
      className={cn(
        `fixed top-20 left-1/2 -translate-x-1/2 z-50 px-5 py-3 rounded shadow-lg font-mono text-center inline-flex items-center gap-3 ${bg} ${className}`
      )}
      style={{ position: 'fixed' }}
    >
      {Icon && <SvgIcon src={Icon} className='w-4 h-4 shrink-0' aria-hidden='true' />}
      <Text variant='body-m' classNames={{ wrapper: 'font-bold' }}>
        {text}
      </Text>
      <Button
        onClick={onClose}
        classNames={{
          root: 'pl-3',
        }}
        slim
        variant='text'
        color='secondary'
        data-tracker-context='banner-close'
      >
        <SvgIcon src={iconXCloseSrc} className='h-4 w-4' />
      </Button>
    </div>
  );
};
